var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.module === "kng"
    ? _c("div", { staticClass: "yxtbiz-kng-operator__upload-tips" }, [
        _c("div", { staticClass: "yxtbiz-flex" }, [
          _c("div", { staticClass: "yxtbiz-flex-1" }, [
            _c(
              "div",
              { staticClass: "yxt-weight-6 standard-size-14 color-gray-9 mb8" },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("pc_kng_upload_tit_upload_info" /**上传须知： */)
                  )
                ),
              ]
            ),
            _c("div", {
              staticClass: "standard-size-12 color-gray-7 lh28",
              domProps: {
                innerHTML: _vm._s(_vm.$t("pc_biz_lbl_uploadnotice")),
              },
            }),
            _c("div", { staticClass: "yxtbiz-flex mt20" }, [
              _c("div", { staticClass: "yxtbiz-flex-1" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "yxt-weight-6 standard-size-14 color-gray-9 mb8",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pc_kng_upload_tit_support_format" /**支持的格式大小： */
                        )
                      )
                    ),
                  ]
                ),
                _c("div", {
                  staticClass: "standard-size-12 color-gray-7 lh28",
                  domProps: { innerHTML: _vm._s(_vm.uploadLimitTip) },
                }),
              ]),
            ]),
          ]),
          _vm.showMiLiDownload
            ? _c(
                "div",
                { staticClass: "yxtbiz-flex-1 ml16" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "yxt-weight-6 standard-size-14 color-gray-9 mb8",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_kng_upload_mili_title" /** 米粒客户端： */)
                        )
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "mt12 yxtbiz-flex-center color-gray-7 standard-size-12",
                    },
                    [
                      _c("yxt-svg", {
                        attrs: {
                          "remote-url":
                            _vm.$staticBaseUrl + "ufd/407a24/kng/pc/svg",
                          width: "108px",
                          height: "49px",
                          "icon-class": _vm.miLiIcon,
                        },
                      }),
                      _c("div", { staticClass: "ml12" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pc_kng_upload_mili_tip3" /** 米粒客户端支持大型文件上传、断点续传、多文件并行上传 */
                              )
                            )
                          ),
                        ]),
                        _c(
                          "div",
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pc_kng_upload_mili_tip4" /** 若未安装客户端 */
                                  )
                                )
                              ),
                            ]),
                            _c(
                              "yxt-button",
                              {
                                staticClass: "ml8 standard-size-12",
                                attrs: { type: "text" },
                                on: { click: _vm.downloadMiLi },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pc_kng_mgmt_btn_mili_down" /** 点我下载 */
                                    )
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "yxt-button",
                    { staticClass: "mt24", on: { click: _vm.openMili } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_kng_mgmt_btn_miliplus_start" /** 客户端上传 */
                          )
                        )
                      ),
                    ]
                  ),
                  _c("yxtbiz-open-download-tool", {
                    ref: "downloadTool",
                    attrs: { module: "kng" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ])
    : _c(
        "div",
        { staticClass: "color-gray-7 mt45 border-dashed border-primary-3 p24" },
        [
          _c("div", [
            _vm._v(
              _vm._s(_vm.$t("pc_kng_upload_tit_upload_info" /**上传须知： */))
            ),
          ]),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.$t("pc_biz_lbl_uploadnotice")) },
          }),
          _c("div", { staticClass: "mt20" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "pc_kng_upload_tit_support_format" /**支持的格式大小： */
                )
              )
            ),
          ]),
          _c("div", { domProps: { innerHTML: _vm._s(_vm.uploadLimitTip) } }),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }